<template>
  <b-row>
    <b-col>
      <b-card body-class="py-2">
        <section class="list-view-heading">
          <ModuleViewHeading :module-id="access.module_id" :profile-id="access.profile_id" :reference="access.view_reference" summary-only />
          <div class="list-view-heading__controls">
            <div class="list-view-heading__actions"><TabHeaderActions /></div>
            <div class="list-view-heading__controls-end"><b-button variant="link" class="list-view-icon-btn" :class="{ 'list-view-icon-btn--active': filtersOpen }" v-b-tooltip.hover.bottom :title="filtersOpen ? 'Ocultar filtros' : 'Mostrar filtros'" :aria-label="filtersOpen ? 'Ocultar filtros' : 'Mostrar filtros'" @click="filtersOpen = !filtersOpen"><AppIcon name="filter" :fill="filtersOpen" /></b-button></div>
          </div>
        </section>
        <b-collapse v-model="filtersOpen">
          <div class="list-view-toolbar__filters">
            <div class="list-view-filter" style="width: 150px;"><label class="filter-label">Desde</label><b-form-input type="date" size="sm" v-model="filters.date_start" /></div>
            <div class="list-view-filter" style="width: 150px;"><label class="filter-label">Hasta</label><b-form-input type="date" size="sm" v-model="filters.date_end" /></div>
            <div class="list-view-filter" style="flex: 1 1 170px; max-width: 230px;"><label class="filter-label">Estado</label><v-select :options="arr.filters.status_imputation" v-model="filters.status_imputation" :multiple="false" :select-on-tab="true" /></div>
            <div class="list-view-filter" style="flex: 1 1 190px; max-width: 260px;"><label class="filter-label">Punto de venta</label><v-select :options="arr.filters.points_sales" v-model="filters.points_sales" :multiple="false" :select-on-tab="true" /></div>
            <div class="list-view-filter" style="flex: 1 1 220px; max-width: 300px;"><label class="filter-label">Clientes</label><v-select :options="arr.filters.customers" v-model="filters.customers" :multiple="true" :select-on-tab="true" /></div>
            <div v-if="moduleSellersActive" class="list-view-filter" style="flex: 1 1 220px; max-width: 300px;"><label class="filter-label">Vendedores</label><v-select :options="arr.filters.sellers" v-model="filters.sellers" :multiple="true" :select-on-tab="true" /></div>
            <b-button variant="outline-dark" size="sm" @click="filterTab" :disabled="table.preload || pivot.preload" v-b-tooltip.hover title="Aplicar filtros" style="height:31px;width:31px;padding:0;flex-shrink:0;"><AppIcon name="filter" /></b-button>
          </div>
        </b-collapse>
      </b-card>
      
      <b-card no-body class="mb-3">
      <b-tabs>
        <b-tab title="IVA Ventas" @click="setTabActive('iva')" :disabled="pivot.preload">
          
          <div v-if="table.items.length && !table.preload" class="sales-reports-toolbar">
              <div class="sales-reports-toolbar__summary"><AppIcon name="receipt_long" /><span>IVA Ventas</span><small>{{ table.items.length }} comprobantes</small></div>
              <div class="sales-reports-toolbar__actions">
              <b-dropdown right size="sm" variant="link" boundary="window" toggle-class="list-view-ghost-btn" no-caret>
                <template #button-content><AppIcon name="view_column" class="mr-1" />Columnas<AppIcon name="chevron-down" class="ml-1" /></template>
                <b-dropdown-form class="sales-reports-columns-menu" @click.stop>
                  <div class="sales-reports-columns-menu__title">Columnas visibles</div>
                  <b-form-checkbox v-for="column in ivaColumnOptions" :key="column.key" v-model="filters.iva_columns" :value="column.key" @change="onIvaColumnsChange">{{ column.label }}</b-form-checkbox>
                </b-dropdown-form>
              </b-dropdown>
              <b-button size="sm" variant="link" class="list-view-ghost-btn" @click="printIvaSales"><AppIcon name="print" class="mr-1" />Imprimir PDF</b-button>
              <b-dropdown right size="sm" variant="link" boundary="window" toggle-class="list-view-ghost-btn" no-caret>
                <template #button-content><AppIcon name="download" class="mr-1" />Exportar<AppIcon name="chevron-down" class="ml-1" /></template>
                <b-dropdown-item>
                  <export-excel
                      :data = "arr.export"
                      worksheet = "IVA Ventas"
                      name = "taxes-sales.xls">
                      <AppIcon name="file-earmark-spreadsheet" class="mr-1" />Excel
                  </export-excel>
                </b-dropdown-item>
                <b-dropdown-item @click="exportFormatIvaDigital()">
                  <AppIcon name="file-earmark-text" class="mr-1" />Libro IVA Ventas Digital
                </b-dropdown-item>
              </b-dropdown>
              </div>
          </div>
          
          <b-row>
            <b-col sm="12" v-if="table.items.length && !table.preload && !table.init">
              <Grid 
                ref="ivaGrid"
                :columns="grid.iva.columns"
                :dataRow="table.items"
                :dataTotal="grid.iva.totales"
                :columnState="ivaGridColumnState"
                :rowHeight="45"
                :gridHeight="'80vh'"
                @column-state-change="saveIvaGridState"
              />
            </b-col>            
          </b-row>

          
          <div class="text-center" v-if="table.preload && !table.init">
            <b-spinner label="Spinning"></b-spinner>
          </div>
          
          <EmptyState v-if="!table.items.length && !table.preload && !table.init" icon="receipt_long" title="No se encontraron registros" />
          <EmptyState v-if="!table.items.length && table.init" icon="filter" title="Configurá los filtros para obtener datos" />
        </b-tab>         
        <b-tab title="Ventas" @click="loadByFilterReport()" :disabled="table.preload">
          <DynamicSummary v-if="!pivot.init" storage-key="dynamic_summary_sales_reports" :dimensions="report.dimensions" :default-groups="report.defaultGroups" :load-report="loadReport" quantity-label="Cantidad" @error="showReportError" />
          <EmptyState v-if="pivot.init" icon="filter" title="Configurá los filtros para obtener datos" />
        </b-tab> 
      </b-tabs>
      </b-card>
      <Printer v-if="crud.print.filters" :filters="crud.print.filters" :reference="crud.print.reference" :key="crud.print.key" />

      <b-card body-class="py-2">
        <b-row>
          <b-col>
            <b-button type="button" variant="outline-dark" size="sm" @click="$router.go(-1)">
              <AppIcon name="back" class="mr-1" />
              Volver
            </b-button>                        
          </b-col>          
        </b-row>
      </b-card>
    
    </b-col>
  </b-row>
</template>
<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import Session from '@/handler/session'  
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper'   
  import Param from '@/config/parameters'
  import moment from 'moment'  
  import Storage from '@/handler/storageSession'
  import DynamicSummary from '@/components/inc/reporting/DynamicSummary'
  import Grid from '@/components/inc/agGrid/index'
  import StorageLocal from '@/handler/storageLocal'
  import TabHeaderActions from '@/components/inc/tabs/TabHeaderActions'
  import Printer from '@/components/inc/printer/printer'

  export default {     
    components: {
      DynamicSummary,
      Grid,
      TabHeaderActions,
      Printer,
    },
    data: () => {
      return {      
        access: {
          module_id: Modules.VENTAS,
          profile_id: Profiles.PERSONAL,
          view_reference: 'reports',
          elements: {}
        },  
        table : {
          items: [],          
          filter: null,
          preload: false,
          init: true,
        }, 
        filtersOpen: false,
        crud: { print: { key: 0, filters: null, reference: 'sales-iva' } },
        ivaColumnsConfigured: false,
        ivaGridColumnState: [],
        pivot: {
          preload: false,
          init: true,
        },
        report: {
          defaultGroups: ['year', 'month'],
          dimensions: [
            { key: 'year', label: 'Año' }, { key: 'month', label: 'Mes' }, { key: 'point_sale', label: 'Punto de venta' },
            { key: 'seller', label: 'Vendedor' }, { key: 'customer', label: 'Cliente' }, { key: 'item', label: 'Ítem' }, { key: 'currency', label: 'Moneda' },
          ],
        },
        grid: {
          iva: {
            columns: [],
            totales: [],
          }          
        },
        arr: {
          filters : {
            customers: [],
            sellers: [],
            points_sales: [],
            status_imputation: [
              {code: true, label: 'Cancelado'},
              {code: false, label: 'Pendiente'}
            ]
          },   
          columns : {
            iva_conditions: [],
          },
          sales: [],                    
        },
        filters: {
          date_start: '',
          date_end: '',
          customers: null,
          sellers: null,
          points_sales: null,
          status_imputation: null,
          paginate: false,
          iva_columns: ['business', 'voucher', 'date', 'date_expiration', 'customer', 'amount_net', 'amount_total'],
        },  
        totals: {
          net: 0,
          total: 0,
        },
        tabs: {
          iva: true,
          report: false,
        }
      }
    },
    created () {     
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      /* Fin configuracion */
    },  
    mounted() {
      this.filterLoad()
      this.filtersOpen = StorageLocal.getValue('filters_open_sales_reports') === 'true'
    },
    watch: {
      filtersOpen(value) {
        StorageLocal.setValue('filters_open_sales_reports', value ? 'true' : 'false')
      }
    },
    computed: {
      // MODULES
      moduleSellersActive() {
        var status = false
        var modules = Session.getSession().auth.user.permissions.modules        
        modules.forEach(element => {
          if(element.id == Modules.VENDEDORES) {                             
            status = true                       
          }
        })        
        return status
      },
      // CONFIGURACION      
      getCurrency() {
        return 'ARS'
      },
      ivaColumnOptions() {
        return [
          { key: 'business', label: 'Empresa' }, { key: 'voucher', label: 'Comprobante' }, { key: 'date', label: 'Fecha' }, { key: 'date_expiration', label: 'Vto.' }, { key: 'customer', label: 'Cliente' }, { key: 'amount_net', label: 'Neto' },
          ...this.arr.columns.iva_conditions.map(item => ({ key: 'iva_' + item.code, label: item.label, iva_id: item.code })), { key: 'amount_total', label: 'Total' },
        ]
      },
    },    
    methods: {
      isIvaColumnVisible(key) { return this.filters.iva_columns.indexOf(key) !== -1 },
      onIvaColumnsChange() {
        this.saveFilterStorage()
        this.$nextTick(() => {
          const grid = this.$refs.ivaGrid
          if(!grid) return
          this.ivaColumnOptions.forEach((column) => {
            grid.setColumnVisibility(this.getIvaGridField(column.key), this.isIvaColumnVisible(column.key))
          })
          this.saveIvaGridState(grid.getColumnState())
        })
      },
      saveIvaGridState(state) {
        if(!Array.isArray(state)) return

        const fields = {}
        this.ivaColumnOptions.forEach(column => { fields[this.getIvaGridField(column.key)] = column.key })

        const gridState = state
          .filter(column => fields[column.colId])
          .map(column => ({ colId: column.colId, width: column.width, hide: column.hide }))

        this.ivaGridColumnState = gridState
        this.filters.iva_columns = gridState.filter(column => !column.hide).map(column => fields[column.colId])
        this.ivaColumnsConfigured = true
        this.saveFilterStorage()
        StorageLocal.setValue('sales_reports_iva_grid', JSON.stringify({
          columns: this.filters.iva_columns,
          state: gridState,
        }))
      },
      restoreIvaGridPreferences() {
        const value = StorageLocal.getValue('sales_reports_iva_grid')
        if(!value) return

        try {
          const preferences = JSON.parse(value)
          if(Array.isArray(preferences.columns)) {
            this.filters.iva_columns = preferences.columns
            this.ivaColumnsConfigured = true
          }
          if(Array.isArray(preferences.state)) this.ivaGridColumnState = preferences.state
        } catch (error) {
          StorageLocal.removeValue('sales_reports_iva_grid')
        }
      },
      getIvaGridField(key) {
        if(key === 'business') return 'business.reference'
        if(key.indexOf('iva_') === 0) {
          const iva = this.arr.columns.iva_conditions.find(item => 'iva_' + item.code === key)
          return iva ? 'amount_iva_' + iva.label : key
        }
        return key
      },
      printIvaSales() {
        this.crud.print.key = Math.random()
        this.crud.print.filters = Object.assign({}, this.filters, {
          point_sale_label: this.filters.points_sales ? this.filters.points_sales.label : 'Todos los puntos de venta',
        })
      },
      filterLoad() {
        this.filterLoadCustomers()          
        this.filterLoadSellers()   
        this.filterLoadPointSale()   
        this.filters.date_start = moment().subtract(30, 'days').format('YYYY-MM-DD') 
        this.filters.date_end = moment().format('YYYY-MM-DD') 
        this.restoreFilterStorage() 
        this.restoreIvaGridPreferences()
        return this.getIvaConditions().then(() => this.loadByFilter())
      },
      filterLoadCustomers() {
        var result = serviceAPI.obtenerClientes()        
        result.then((response) => {
          var data = response.data    

          this.arr.filters.customers = []
          data.forEach(element => {         
            if(element.code) {
              this.arr.filters.customers.push({ code: element.id, label: element.code + ' | ' + element.name })            
            } else {
              this.arr.filters.customers.push({ code: element.id, label: element.name })            
            }                             
          });          
        })   
      },
      filterLoadSellers() {
        var result = serviceAPI.obtenerVendedores()        
        result.then((response) => {
          var data = response.data    

          this.arr.filters.sellers = []
          data.forEach(element => {                            
            this.arr.filters.sellers.push({ code: element.id, label: element.name })            
          });          
        })   
      },
      filterLoadPointSale() {
        var result = serviceAPI.obtenerPuntosVentas()        
        result.then((response) => {
          var data = response.data    

          this.arr.filters.points_sales = []
          data.forEach(element => {                            
            this.arr.filters.points_sales.push({ code: element.id, label: element.full_identification })            
          });          
        })   
      },   
      getIvaConditions() {
        var result = serviceAPI.obtenerCondicionesIva()
        return result.then((response) => {
          var data = response.data    

          data.forEach(element => {            
            this.arr.columns.iva_conditions.push({ code: element.id, label: element.name, total_net: 0, total_iva: 0 })
          });
          this.arr.columns.iva_conditions.forEach(item => {
            const key = 'iva_' + item.code
            if(!this.ivaColumnsConfigured && this.filters.iva_columns.indexOf(key) === -1) this.filters.iva_columns.push(key)
          })
        })
      },
      filterTab() {
        if(this.tabs.iva){
          this.loadByFilter()    
        } else {
          this.loadByFilterReport()    
        }
      },
      setTabActive(type) {
        if(type == 'iva') {
          this.tabs.iva = true
          this.tabs.report = false
        }
        if(type == 'report') {
          this.tabs.iva = false
          this.tabs.report = true
        }        
      },
      loadByFilter() {     
        this.saveFilterStorage()

        this.table.init = false
        this.table.preload = true

        this.tabs.iva = true
        this.tabs.report = false

        this.totals.net = 0
        this.totals.total = 0

        this.arr.columns.iva_conditions.forEach(elementIva => {
          elementIva.total_net = 0,
          elementIva.total_iva = 0
        });

        var result = serviceAPI.filtrarIvaSales(this.filters)

        result.then((response) => {          
          var data = response.data
          this.arr.sales = data
          this.table.items = data

          data.forEach(element => {
            element['amount_net'] = 0

            this.arr.columns.iva_conditions.forEach(elementIva => {
              element['amount_iva_' + elementIva.label] = 0              

              element.details.forEach(elementDet => {
                if(elementDet.iva_conditions_id == elementIva.code){
                  if(elementDet.amount_iva > 0){
                    
                    element['amount_iva_' + elementIva.label] = element['amount_iva_' + elementIva.label] + parseFloat(elementDet.amount_iva)
                    element['amount_net'] = element['amount_net'] + parseFloat(elementDet.amount_net)
                                        
                    if(element.type_voucher.type_balance == '-'){  
                      elementIva.total_iva = elementIva.total_iva - (parseFloat(elementDet.amount_iva) - ((parseFloat(elementDet.amount_iva) * element.percentage_discount) / 100))
                    } else {
                      elementIva.total_iva = elementIva.total_iva + (parseFloat(elementDet.amount_iva) - ((parseFloat(elementDet.amount_iva) * element.percentage_discount) / 100))
                    }

                    if(element.type_voucher.type_balance == '-'){
                      this.totals.net = this.totals.net - (parseFloat(elementDet.amount_net) - ((parseFloat(elementDet.amount_net) * element.percentage_discount) / 100))
                    } else {
                      this.totals.net = this.totals.net + (parseFloat(elementDet.amount_net) - ((parseFloat(elementDet.amount_net) * element.percentage_discount) / 100))
                    }
                  } else {
                    element['amount_iva_' + elementIva.label] = element['amount_iva_' + elementIva.label] + parseFloat(elementDet.amount_net)

                    if(element.type_voucher.type_balance == '-'){
                      elementIva.total_net = elementIva.total_net - (parseFloat(elementDet.amount_net) - ((parseFloat(elementDet.amount_net) * element.percentage_discount) / 100))
                    } else {
                      elementIva.total_net = elementIva.total_net + (parseFloat(elementDet.amount_net) - ((parseFloat(elementDet.amount_net) * element.percentage_discount) / 100))
                    }
                  }
                }
              });

              element['amount_iva_' + elementIva.label] = element['amount_iva_' + elementIva.label] - ((element['amount_iva_' + elementIva.label] * element.percentage_discount) / 100)
            });
            
            element['amount_net'] = element['amount_net'] - ((element['amount_net'] * element.percentage_discount) / 100)         

            if(element.type_voucher.type_balance == '-'){
              this.totals.total = this.totals.total - parseFloat(element.amount_total)
            } else {
              this.totals.total = this.totals.total + parseFloat(element.amount_total)
            }            
          });

          this.gridDefColumns()          

          this.table.preload = false
          this.prepareExport(data)
        })
        .catch(error => {          
          this.table.preload = false
          this.$awn.alert(Error.showError(error))
        });
      },   
      loadByFilterReport() {
        this.pivot.init = false
        this.pivot.preload = false
        
        this.tabs.iva = false
        this.tabs.report = true

      },
      loadReport(params) {
        return serviceAPI.filtrarReportSalesSummary(Object.assign({}, this.filters, params))
      },
      showReportError(error) {
        this.$awn.alert(Error.showError(error))
      },
      prepareExport(data) {        
        this.arr.export = []

        data.forEach(element => {
          var businessID = 0
          var businessName = ""          
          var customersName = ""
          var customersCUIT = ""
          var customersCondFiscal = ""          
          var voucherReference = ""
          const sign = (element.type_voucher && element.type_voucher.type_balance == '-') ? -1 : 1
          const formatAmount = (value) => {
            const amount = (Math.abs(parseFloat(value)) || 0) * sign
            return amount.toFixed(2).replace('.',',')
          }

          if(element.business && element.business.reference) {
            businessID = element.business.id            
            businessName = element.business.reference
          }
          if(element.customer) {            
            customersName = element.customer.name
            customersCUIT = element.customer.data_fiscal.documents_number
            customersCondFiscal = element.customer.data_fiscal.fiscal_condition.name
          }          
          if(element.type_voucher) {            
            voucherReference = element.type_voucher.name + ' ' + element.point_sale.point_sale.toString().padStart(4,'0') + '-' + element.number.toString().padStart(8,'0')
          }
          
          var arrExport = []
          arrExport["business"] = businessName,
          arrExport["voucherReference"] = voucherReference,      
          arrExport["date"] = element.date,
          arrExport["date_expiration"] = element.date_expiration,    
          arrExport["customersName"] = customersName,            
          arrExport["customersCUIT"] = customersCUIT,
          arrExport["customersCondFiscal"] = customersCondFiscal,

          arrExport['amount_net'] = formatAmount(element.amount_net),

          this.arr.columns.iva_conditions.forEach(elementIva => {
            arrExport['amount_iva_' + elementIva.label] = formatAmount(element['amount_iva_' + elementIva.label])
          });

          arrExport["amount_total"] = formatAmount(element.amount_total),

          this.arr.export.push(arrExport)
        });
      },

      processPivot(data) {
        var addData = []        
        data.forEach(element => {
          addData.push({
            date: element.date,
            staff: (element.staffId) ? element.staffName : '',
            seller: (element.sellerId) ? element.sellerName: 'Sin vendedor',
            type_voucher: (element.typeVoucherName) ? element.typeVoucherName : '',
            point_sale: (element.pointSaleId) ? element.pointSaleId : '',
            customer: (element.customerId) ? element.customerName : '',
            number: element.number,            
            amount_total: element.total,
          })
        });

        return {
          dataSource: {                  
            data: addData,
          },
          slice: {
            rows: [
              {
                uniqueName: "seller",
                sort: "asc",
              },                 
              {
                uniqueName: "staff",
                sort: "asc",
              },              
              {
                uniqueName: "customer",
                sort: "asc",
              },                            
            ],
            columns: [
              {
                uniqueName: "date.Month",
                sort: "asc",
              },                  
            ],
            measures: [
              {
                uniqueName: "amount_total",
                aggregation: "sum"
              },                                   
            ],
            expands: {
              expandAll: false,
              rows: [],
              columns: []
            },
            drills: {
              drillAll: false
            }
          },
          options: {
            grid: {
              type: "compact",
              title: "",
              showFilter: true,
              showHeaders: true,
              showTotals: false,
              showGrandTotals: "off",
              showHierarchies: true,
              showHierarchyCaptions: true,
              showReportFiltersArea: true
            },
            configuratorActive: false,
            configuratorButton: true,
            showAggregations: true,
            showCalculatedValuesButton: true,
            drillThrough: true,
            showDrillThroughConfigurator: true,
            sorting: "on",
            datePattern: "dd/MM/yyyy",
            dateTimePattern: "dd/MM/yyyy HH:mm:ss",
            saveAllFormats: false,
            showDefaultSlice: true,
            defaultHierarchySortName: "asc"
          },
          formats: [
            {
              name: "",
              thousandsSeparator: " ",
              decimalSeparator: ".",
              decimalPlaces: 2,
              maxSymbols: 20,
              currencySymbol: "",
              currencySymbolAlign: "left",
              nullValue: " ",
              infinityValue: "Infinity",
              divideByZeroValue: "Infinity"
            }
          ],
          localization: "/static/webdatarocks/es.json"                     
        }    
      }, 
      
      // IVA DIGITAL
      exportFormatIvaDigital() {
        let header = ''        
        let details = ''  
        this.arr.sales.forEach(element => {          

          // cambio de cliente en el proceso de facturacion (cambio de venta global a un cliente identificado)
          let type_document_code_afip = element.customer.data_fiscal.type_document.code_afip
          let documents_number = element.customer.data_fiscal.documents_number
          let business_name = element.customer.business_name
          if(element.customer_identification) {
            let customer_identification = JSON.parse(element.customer_identification)

            if(customer_identification.documents_number && customer_identification.name) {
              type_document_code_afip = 96
              documents_number = customer_identification.documents_number
              business_name = customer_identification.name
            }
          }         
          
          // cantidad de alicuotas
          let cantAlicuotas = 0
          if(parseFloat(element["amount_iva_0%"])) {
            cantAlicuotas++
          }
          if(parseFloat(element["amount_iva_10,50%"])) {
            cantAlicuotas++
          }
          if(parseFloat(element["amount_iva_21%"])) {
            cantAlicuotas++
          }
          if(parseFloat(element["amount_iva_27%"])) {
            cantAlicuotas++
          }                                                                   

					header += moment(element.date).format('YYYY').toString().padStart(4,'0') + moment(element.date).format('MM').toString().padStart(2,'0') + moment(element.date).format('DD').toString().padStart(2,'0');
          header += element.type_voucher.code_afip.toString().padStart(3,'0');
          header += element.point_sale.point_sale.toString().padStart(5,'0');
          header += element.number.toString().padStart(20,'0');
          header += element.number.toString().padStart(20,'0');
          header += type_document_code_afip.toString().padStart(2,'0');
          header += documents_number.toString().padStart(20,'0');          
          header += business_name.toString().normalize("NFD").replace(/[\u0300-\u036f]/g, "").trim().slice(0,30).padEnd(30,' ');          
          header += this.formatNumbersForExport(element.amount_total);
          header += this.formatNumbersForExport(element["amount_iva_No Gravado"]);
          header += this.formatNumbersForExport(0);
          header += this.formatNumbersForExport(element["amount_iva_Exento"]);
          header += this.formatNumbersForExport(0);
          header += this.formatNumbersForExport(0);
          header += this.formatNumbersForExport(0);
          header += this.formatNumbersForExport(0);
          header += "PES";          
          header += "0001000000";          
          header += cantAlicuotas.toString().padStart(1,'0');
          header += "0";
          header += this.formatNumbersForExport(0);
          header += moment(element.date_expiration).format('YYYY').toString().padStart(4,'0') + moment(element.date_expiration).format('MM').toString().padStart(2,'0') + moment(element.date_expiration).format('DD').toString().padStart(2,'0');
          header += '\r\n';


          // obtiene total de los detalles de alicuotas  
          let arr = []
          element.details.forEach(iva => {          
            if(!arr[iva.iva_conditions_id]) {
              arr[iva.iva_conditions_id] = []
              arr[iva.iva_conditions_id]["amount_iva"] = 0
              arr[iva.iva_conditions_id]["amount_net"] = 0
            }

            arr[iva.iva_conditions_id]["amount_iva"] = arr[iva.iva_conditions_id]["amount_iva"] + parseFloat(iva.amount_iva)
            arr[iva.iva_conditions_id]["amount_net"] = arr[iva.iva_conditions_id]["amount_net"] + parseFloat(iva.amount_net)
          });       

          arr.forEach((item, key) => {            
            details += element.type_voucher.code_afip.toString().padStart(3,'0');
            details += element.point_sale.point_sale.toString().padStart(5,'0');
            details += element.number.toString().padStart(20,'0');
            details += this.formatNumbersForExport(this.round(item.amount_net));
            details += key.toString().padStart(4,'0');
            details += this.formatNumbersForExport(this.round(item.amount_iva));                             
            details += '\r\n';
          })          
        });        

        this.downloadTXT("iva_venta_cabecera.txt", header);                    
        this.downloadTXT("iva_venta_alicuotas.txt", details);                    
      },
      round(number) {        
        return Math.round((parseFloat(number) + Number.EPSILON) * 100) / 100;        
      },
      formatNumbersForExport(value) {
        // Convertir a valor absoluto para siempre usar valores positivos
        let absValue = Math.abs(parseFloat(value));
        let number = absValue.toString().split('.')[0].padStart(13,'0')
        if(absValue.toString().split('.')[1]) {
          number += absValue.toString().split('.')[1].padEnd(2,'0')
        } else {
          number += '00'
        }
        return number
      },      
      downloadTXT(nameFile, content) {        
        const blob = new Blob([content], { type: "text/plain" });

        const enlace = document.createElement("a");
        enlace.href = URL.createObjectURL(blob);
        enlace.download = nameFile;

        enlace.style.display = "none";
        document.body.appendChild(enlace);
        enlace.click();

        document.body.removeChild(enlace);
        URL.revokeObjectURL(enlace.href);
      },

      // GRID
      gridDefColumns() {
        // Definicion de columnas
        let cols1 = [
          { 
            headerName: "Empresa", 
            field: "business.reference", 
            width: 100,
          },          
          { 
            headerName: "Comprobante", 
            field: "voucher", 
            width: 250, 
            sortable: false, 
            filter: false, 
            cellRenderer: (params) => {
              const item = params.data;

              if (!item || !item.type_voucher || !item.point_sale) return '';

              const isError = item.afip_error && !item.point_sale.nd;
              const isSuccess = item.afip && item.afip_qr && !item.point_sale.nd;

              const cssClass = isError 
                ? 'text-danger font-weight-bold'
                : isSuccess 
                  ? 'text-success font-weight-bold'
                  : '';

              const title = isError ? 'Error AFIP' : '';

              const formattedNumber = 
                item.point_sale.point_sale.toString().padStart(4, '0') +
                '-' +
                item.number.toString().padStart(8, '0');

              return `
                <div class="${cssClass}" title="${title}">
                  ${item.type_voucher.name} <br> ${formattedNumber}
                </div>
              `;
            }                     
          },
          { 
            headerName: "Fecha", 
            field: "date", 
            width: 120,             
            cellClass: 'text-left', 
            valueFormatter: function(params) { 
              if(!params.value) return ''
              return moment(params.value).format('DD/MM/YYYY') 
            } 
          },     
          { 
            headerName: "Vto", 
            field: "date_expiration", 
            width: 120,             
            cellClass: 'text-left', 
            valueFormatter: function(params) { 
              if(!params.value) return ''
              return moment(params.value).format('DD/MM/YYYY') 
            } 
          },               
          { 
            headerName: "Cliente", 
            field: "customer", 
            width: 250,   
            sortable: false, 
            filter: false,             
            cellStyle: { 
              'line-height': '1.2 !important',              
            },                     
            cellRenderer: (params) => {
              const item = params.data;

              if (!item || !item.customer) return '';              

              return `                
                  <span style="font-size: 12px;">${item.customer.data_fiscal.documents_number} / ${item.customer.data_fiscal.fiscal_condition.name}</span>     
                  <br>               
                  <span class="font-weight-bold">${item.customer.name}</span>                
              `;
            }              
          },
          { 
            headerName: "Neto", 
            field: "amount_net", 
            width: 110,    
            filter: false, 
            cellStyle: {               
              'text-align': 'right',
              'align-content': 'space-around',
            },            
            cellRenderer: (params) => {
              let item = params.data;
              
              const isSummary = item.summary_amount_net != undefined;
              if(isSummary) {
                item = item.summary_amount_net;
              }

              if (!item || !item.currency) return '';              

              const isNegative = item.type_voucher.type_balance == '-';
              const isPositive = item.type_voucher.type_balance == '+';

              if(isSummary) {
                return `
                  <div style="color:black;">
                    <b>${Intl.NumberFormat('es-AR',{style:'currency',currency: item.currency.code}).format(item.amount_net)}</b>
                  </div>
                `;
              }               
              if(isNegative) {
                return `
                  <div style="color:red;">
                    <b>(${Intl.NumberFormat('es-AR',{style:'currency',currency: item.currency.code}).format(item.amount_net)})</b>
                  </div>
                `;
              }
              if(isPositive) {
                return `
                  <div style="color:green;">
                    <b>${Intl.NumberFormat('es-AR',{style:'currency',currency: item.currency.code}).format(item.amount_net)}</b>
                  </div>
                `;
              }              
            }  
          },          
        ]
          
        let childCols2 = []
        for (const key in this.arr.columns.iva_conditions) {          
          const iva = this.arr.columns.iva_conditions[key]

          childCols2.push(
            { 
              headerName: iva.label, 
              field: "amount_iva_" + iva.label, 
              width: 110,   
              filter: false,           
              cellStyle: {               
                'text-align': 'right',
                'align-content': 'space-around',
              },            
              cellRenderer: (params) => {                
                let item = params.data;
                
                const isSummary = item["summary_" + iva.label] != undefined;
                if(isSummary) {
                  item = item["summary_" + iva.label];
                }

                if (!item || !item.currency) return '';              
                
                const isNegative = item.type_voucher.type_balance == '-';
                const isPositive = item.type_voucher.type_balance == '+';

                if(isSummary) {
                  return `
                    <div style="color:black;">
                      <b>${Intl.NumberFormat('es-AR',{style:'currency',currency: item.currency.code}).format(item['amount_iva_' + iva.label])}</b>
                    </div>
                  `;
                } 
                if(isNegative) {
                  return `
                    <div style="color:red;">
                      <b>(${Intl.NumberFormat('es-AR',{style:'currency',currency: item.currency.code}).format(item['amount_iva_' + iva.label])})</b>
                    </div>
                  `;
                }
                if(isPositive) {
                  return `
                    <div style="color:green;">
                      <b>${Intl.NumberFormat('es-AR',{style:'currency',currency: item.currency.code}).format(item['amount_iva_' + iva.label])}</b>
                    </div>
                  `;
                }              
              }  
            },                    
          ) 
        }
        let cols2 = [{
          headerName: "Detalle de IVA",
          children: childCols2
        }]        

        const visibleStaticColumns = {
          'business.reference': 'business', voucher: 'voucher', date: 'date',
          date_expiration: 'date_expiration', customer: 'customer', amount_net: 'amount_net', amount_total: 'amount_total',
        }
        cols1.forEach(column => { column.hide = !this.isIvaColumnVisible(visibleStaticColumns[column.field]) })
        childCols2.forEach(column => {
          const iva = this.arr.columns.iva_conditions.find(item => 'amount_iva_' + item.label === column.field)
          column.hide = !iva || !this.isIvaColumnVisible('iva_' + iva.code)
        })

        let cols3 = [          
          { 
            headerName: "Total", 
            field: "amount_total", 
            width: 110, 
            filter: false, 
            cellStyle: {               
              'text-align': 'right',
              'align-content': 'space-around',              
            },   
            cellRenderer: (params) => {
              let item = params.data;
              
              const isSummary = item.summary_amount_total != undefined;
              if(isSummary) {
                item = item.summary_amount_total;
              }

              if (!item || !item.currency) return '';              

              const isNegative = item.type_voucher.type_balance == '-';
              const isPositive = item.type_voucher.type_balance == '+';

              if(isSummary) {
                return `
                  <div style="color:black;">
                    <b>${Intl.NumberFormat('es-AR',{style:'currency',currency: item.currency.code}).format(item.amount_total)}</b>
                  </div>
                `;
              }                        
              if(isNegative) {
                return `
                  <div style="color:red;">
                    <b>(${Intl.NumberFormat('es-AR',{style:'currency',currency: item.currency.code}).format(item.amount_total)})</b>
                  </div>
                `;
              }
              if(isPositive) {
                return `
                  <div style="color:green;">
                    <b>${Intl.NumberFormat('es-AR',{style:'currency',currency: item.currency.code}).format(item.amount_total)}</b>
                  </div>
                `;
              }              
            }  
          },                                   
        ] 
        cols3.forEach(column => { column.hide = !this.isIvaColumnVisible(visibleStaticColumns[column.field]) })

        this.grid.iva.columns = [
          ...cols1,
          ...cols2,
          ...cols3,
        ]                   
                
        // Definicion de totales     
        let totales = [{
          summary_amount_net:{
            amount_net: parseFloat(this.totals.net),
            currency: { code: this.getCurrency },
            type_voucher: { type_balance: parseFloat(this.totals.net) >= 0 ? '+' : '-' },
          },                                       
          summary_amount_total: {
            amount_total: parseFloat(this.totals.total),
            currency: { code: this.getCurrency },
            type_voucher: { type_balance: parseFloat(this.totals.total) >= 0 ? '+' : '-' },
          }
        }]

        for (const key in this.arr.columns.iva_conditions) {          
          const iva = this.arr.columns.iva_conditions[key]

          let importe = parseFloat(iva.total_iva) > 0 ? iva.total_iva : iva.total_net

          if(!totales[0]["summary_"+iva.label]) {
            totales[0]["summary_"+iva.label] = []
            totales[0]["summary_"+iva.label]["amount_iva_"+iva.label] = parseFloat(importe)
            totales[0]["summary_"+iva.label]["currency"] = { code: this.getCurrency }
            totales[0]["summary_"+iva.label]["type_voucher"] = { type_balance: parseFloat(importe) >= 0 ? '+' : '-' }                        
          }         
        }        

        this.grid.iva.totales = totales
      },
      
      // FILTROS SAVE
      saveFilterStorage() {
        Storage.setValue('reports_sales', JSON.stringify(this.filters))
      },
      restoreFilterStorage() {
        if(Storage.getValue('reports_sales')) {
          this.filters = JSON.parse(Storage.getValue('reports_sales'))
          this.ivaColumnsConfigured = Array.isArray(this.filters.iva_columns)
        }         
        if(!Array.isArray(this.filters.iva_columns)) this.filters.iva_columns = ['business', 'voucher', 'date', 'date_expiration', 'customer', 'amount_net', 'amount_total']
      },          
    }    
  }
</script>
<style scoped>
  .sales-reports-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 10px 12px;
    border-bottom: 1px solid var(--app-color-border);
    background: var(--app-color-surface-subtle);
  }
  .sales-reports-toolbar__summary,
  .sales-reports-toolbar__actions {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .sales-reports-toolbar__summary {
    color: var(--app-color-text-primary);
    font-size: var(--app-text-sm);
    font-weight: 700;
  }
  .sales-reports-toolbar__summary > :first-child { color: var(--app-color-primary); font-size: 18px; }
  .sales-reports-toolbar__summary small {
    padding-left: 8px;
    border-left: 1px solid var(--app-color-border);
    color: var(--app-color-text-secondary);
    font-size: var(--app-text-xs);
    font-weight: 500;
  }
  .sales-reports-columns-menu { min-width: 220px; padding: 8px 12px; }
  .sales-reports-columns-menu__title {
    margin-bottom: 7px;
    color: var(--app-color-text-secondary);
    font-size: var(--app-text-xs);
    font-weight: 700;
    text-transform: uppercase;
  }
  @media (max-width: 767.98px) {
    .sales-reports-toolbar { align-items: flex-start; flex-direction: column; }
    .sales-reports-toolbar__actions { flex-wrap: wrap; }
  }
</style>
